@if (document$ | async; as document) {
  <!-- Document was successfully loaded. -->
  <ng-container *ngTemplateOutlet="documentToolbar"></ng-container>
  <div>
    <ng-container *ngTemplateOutlet="unsupportedDocument"></ng-container>
    @switch (displayMode) {
      @case ('inbox') {
        <ng-container *ngTemplateOutlet="inboxView"></ng-container>
      }
      @case ('inboxIndexing') {
        <ng-container *ngTemplateOutlet="inboxView"></ng-container>
      }
      @case ('archiveImport') {
        <app-document-view-sidebar
          #rightSidebar
          [archiveId]="archiveId"
          [documentId]="0"
          [documentSecureId]="''"
          [uniqueId]="importUniqueId"
          [viewerPageNumber]="pageNumber"
          [permissions]="documentPermissions"
          [fieldValues]="importFieldValues()"
        >
          <div class="view-container" [ngStyle]="viewerContainerStyle">
            @if (showArchiveImportPreview) {
              @if (pdfOptions) {
                <app-pdf-viewer
                  #pdfViewer
                  [pdf-options]="pdfOptions"
                  [excludedClientFormats]="excludedClientSideFormats"
                  [appKeyfree]="kfiActive"
                  [appKeyfreeForceOcr]="forceOcr"
                  [appKeyfreeAutoOcr]="autoOcr"
                  [appKeyfreeIndexer]="rightSidebar.indexer"
                  [appKeyfreePdfViewer]="pdfViewer"
                  (appKeyfreeLastFieldFilled)="kfiActive = false"
                  (loadFailure)="onLoadFailure()"
                  (pageChange)="onPageChange($event)"
                  (documentLoadingChange)="onDocumentLoadingChange($event)"
                  (documentEmailDataLoaded)="onDocumentEmailDataLoaded($event)"
                  (afterPrint)="onAfterPrint()"
                ></app-pdf-viewer>
              }
            } @else {
              <app-import-viewer-unavailable></app-import-viewer-unavailable>
            }
          </div>
          <div>
            @if (showTableFieldGrid) {
              <app-table-field-grid
                #tableFieldGrid
                [archiveId]="archiveId"
                [editModeEnabled]="!this.isGuest"
              ></app-table-field-grid>
            }
          </div>
        </app-document-view-sidebar>
      }
      @default {
        <app-document-view-sidebar
          #rightSidebar
          [archiveId]="archiveId"
          [documentId]="documentAsSearchResult.id"
          [documentSecureId]="documentAsSearchResult.secureId"
          [fieldValues]="documentAsSearchResult.fields"
          [viewerPageNumber]="pageNumber"
          [workflowProcessId]="documentAsSearchResult.workflowProcessId"
          [workflowQueueDocumentMetadata]="workflowQueuedDocument()"
          [permissions]="documentPermissions"
          (indexerDataXChangeMatchApplied)="onIndexerDataXChangeMatchApplied()"
          (userActionExecuted)="onUserActionExecuted($event)"
          (indexerFieldBlurred)="onIndexerFieldBlurred($event)"
          (indexerFieldMultiValueEntryRemoved)="
            onIndexerFieldMultiValueEntryRemoved($event)
          "
        >
          <div class="thumbnailer-viewer-container">
            @if (shouldShowModifyThumbnailer) {
              <app-pdf-thumbnail-viewer
                #thumbnailViewer
                [appPdfThumbnailerEventHandler]="thumbnailViewer"
                [appPdfThumbnailerEventHandlerViewer]="pdfviewer"
                [appPdfThumbnailerHandlerFields]="documentAsSearchResult.fields"
                [hasModifyPermissions]="
                  documentPermissions.modifyDocumentPages &&
                  documentPermissions.modifyDocuments
                "
                [pdfBytes]="pdfviewer.pdfBytes"
                [thumbnails]="pdfviewer.thumbnails"
                (pdfModified)="onPdfModified($event)"
              >
              </app-pdf-thumbnail-viewer>
            }
            @if (rightSidebar.resizeInProgress) {
              <div class="resize-overlay"></div>
            }
            <div class="viewer-container" [ngStyle]="viewerContainerStyle">
              @if (pdfOptions) {
                <app-pdf-viewer
                  #pdfViewer
                  [pdf-options]="pdfOptions"
                  [excludedClientFormats]="excludedClientSideFormats"
                  [appKeyfree]="kfiActive"
                  [appKeyfreeAutoOcr]="autoOcr"
                  [appKeyfreeForceOcr]="forceOcr"
                  [appKeyfreeIndexer]="rightSidebar.indexer"
                  [appKeyfreePdfViewer]="pdfViewer"
                  (appKeyfreeLastFieldFilled)="kfiActive = false"
                  (loadFailure)="onLoadFailure()"
                  (pageChange)="onPageChange($event)"
                  (documentLoadingChange)="onDocumentLoadingChange($event)"
                  (documentEmailDataLoaded)="onDocumentEmailDataLoaded($event)"
                  (afterPrint)="onAfterPrint()"
                ></app-pdf-viewer>
              }
            </div>
          </div>
          <div>
            @if (showTableFieldGrid) {
              <app-table-field-grid
                #tableFieldGrid
                [archiveId]="archiveId"
                [editModeEnabled]="!this.isGuest"
                [viewingRevision]="displayMode === 'archiveRevision'"
                (tableDataSaved)="onTableDataSaved()"
              ></app-table-field-grid>
            }
          </div>
        </app-document-view-sidebar>
      }
    }
    <ng-template #inboxView>
      @if (inboxTargetArchiveId === 0) {
        <div class="viewer-container" [ngStyle]="viewerContainerStyle">
          @if (pdfOptions) {
            <app-pdf-viewer
              [pdf-options]="pdfOptions"
              [excludedClientFormats]="excludedClientSideFormats"
              (loadFailure)="onLoadFailure()"
              (pageChange)="onPageChange($event)"
              (documentLoadingChange)="onDocumentLoadingChange($event)"
              (documentEmailDataLoaded)="onDocumentEmailDataLoaded($event)"
              (afterPrint)="onAfterPrint()"
            ></app-pdf-viewer>
          }
        </div>
      } @else {
        <app-document-view-sidebar
          #rightSidebar
          [archiveId]="inboxTargetArchiveId"
          [documentId]="0"
          [documentSecureId]="''"
          [viewerPageNumber]="pageNumber"
          [permissions]="documentPermissions"
          [uniqueId]="importUniqueId"
        >
          <div class="viewer-container" [ngStyle]="viewerContainerStyle">
            @if (pdfOptions) {
              <app-pdf-viewer
                [pdf-options]="pdfOptions"
                [excludedClientFormats]="excludedClientSideFormats"
                [appKeyfree]="kfiActive"
                [appKeyfreeAutoOcr]="autoOcr"
                [appKeyfreeForceOcr]="forceOcr"
                [appKeyfreeIndexer]="rightSidebar.indexer"
                [appKeyfreePdfViewer]="pdfviewer"
                (appKeyfreeLastFieldFilled)="kfiActive = false"
                (loadFailure)="onLoadFailure()"
                (pageChange)="onPageChange($event)"
                (documentLoadingChange)="onDocumentLoadingChange($event)"
                (documentEmailDataLoaded)="onDocumentEmailDataLoaded($event)"
                (afterPrint)="onAfterPrint()"
              ></app-pdf-viewer>
            }
          </div>
          <div>
            @if (showTableFieldGrid) {
              <app-table-field-grid
                #tableFieldGrid
                [archiveId]="inboxTargetArchiveId"
                [editModeEnabled]="!this.isGuest"
              ></app-table-field-grid>
            }
          </div>
        </app-document-view-sidebar>
      }
    </ng-template>
  </div>
  <!-- Action menu. -->
  @switch (displayMode) {
    @case ('archive') {
      <ng-container *ngTemplateOutlet="archiveActions"></ng-container>
    }
    @case ('inbox') {
      <ng-container *ngTemplateOutlet="inboxActions"></ng-container>
    }
    @case ('inboxIndexing') {
      <ng-container *ngTemplateOutlet="inboxActions"></ng-container>
    }
    @case ('task') {
      <ng-container *ngTemplateOutlet="taskSearchActions"></ng-container>
    }
  }
  <ng-template #archiveActions>
    <app-archive-actions-menu
      #actionMenuComponent
      [searchResults]="[documentAsSearchResult]"
      [hideOpen]="true"
      [hideMultiple]="true"
      (refreshSearch)="onRefreshSearch($event)"
      (openSelectedDocuments)="onOpenSearchResults($event)"
      [(modifyDocumentEnabled)]="showModifyDocumentThumbnailer"
    ></app-archive-actions-menu>
  </ng-template>
  <ng-template #inboxActions>
    <app-inbox-actions-menu
      [inboxFiles]="[documentAsInboxFile]"
      #actionMenuComponent
      [hideOpen]="true"
      [hideMultiple]="true"
      (refreshInbox)="onRefreshSearch($event)"
      (openSelectedDocuments)="onOpenInboxDocuments($event)"
    ></app-inbox-actions-menu>
  </ng-template>
  <ng-template #taskSearchActions>
    <app-task-action-menu
      #actionMenuComponent
      [hideOpen]="true"
      [hideMultiple]="true"
      [hideUserActions]="true"
      (refreshSearch)="onRefreshSearch($event)"
      (openSelectedDocuments)="onOpenTaskViewDocuments($event)"
    ></app-task-action-menu>
  </ng-template>
  <!-- Document toolbar. -->
  <ng-template #documentToolbar>
    <mat-toolbar>
      <!-- Toggle menu. -->
      @if (shouldShowNavigationToggle) {
        <app-left-sidebar-toggle-button></app-left-sidebar-toggle-button>
      }
      <!-- Return to search results. -->
      @if (!isRestrictedUser) {
        <button
          mat-icon-button
          (click)="onClickReturnToSearch()"
          [matTooltip]="'RESULTS' | transloco"
          matTooltipShowDelay="1000"
          matTooltipPosition="below"
        >
          <mat-icon>manage_search</mat-icon>
        </button>
      }
      <!-- If the menu toggle won't be shown, offset for it. -->
      @if (!shouldShowNavigationToggle) {
        <span class="single-icon-offset"></span>
      }
      <span class="spacer"></span>
      <!-- Document pager. -->
      @if (isMultipleDocuments) {
        <button
          mat-icon-button
          [matTooltip]="'PREVIOUS' | transloco"
          matTooltipShowDelay="1000"
          matTooltipPosition="below"
          (click)="onClickBack()"
          [disabled]="!isPreviousAvailable"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
        @if (documentOfDocuments) {
          <mat-chip-listbox class="toolbar-label">
            <mat-chip-option>
              {{ documentOfDocuments.current }}
              {{ 'OF' | transloco | lowercase }}
              {{ documentOfDocuments.total }}
            </mat-chip-option>
          </mat-chip-listbox>
        }
        <button
          mat-icon-button
          [matTooltip]="'NEXT' | transloco"
          matTooltipShowDelay="1000"
          matTooltipPosition="below"
          (click)="onClickForward()"
          [disabled]="!isNextAvailable"
        >
          <mat-icon>arrow_forward</mat-icon>
        </button>
      }
      <!-- Right side controls. -->
      <span class="spacer"></span>
      <ngx-compactable-row #compactableRow checkAvailableSpaceAfterViewCheck>
        @if (isGuest || isRestrictedUser) {
          <ng-template ngxCompactableItem let-location="location">
            @if (location === 'menu') {
              <app-copy-link-button
                #copyLinkButton
                [attr.data-toolbar-location]="location"
                [inMenu]="true"
                [includeUser]="true"
                matTooltipPosition="below"
              ></app-copy-link-button>
            } @else {
              <app-copy-link-button
                [includeUser]="true"
                [attr.data-toolbar-location]="location"
                matTooltipPosition="below"
              ></app-copy-link-button>
            }
          </ng-template>

          <ng-template ngxCompactableItem let-location="location">
            @if (location === 'menu') {
              <button
                mat-menu-item
                [attr.data-toolbar-location]="location"
                [disabled]="isDownloadDisabled"
                (click)="onClickDownloadDocument()"
              >
                <mat-icon>file_download</mat-icon>
                <span transloco="DOWNLOAD"></span>
              </button>
            } @else {
              <button
                mat-icon-button
                [attr.data-toolbar-location]="location"
                [disabled]="isDownloadDisabled"
                [matTooltip]="'DOWNLOAD' | transloco"
                matTooltipShowDelay="1000"
                matTooltipPosition="below"
                (click)="onClickDownloadDocument()"
              >
                <mat-icon>file_download</mat-icon>
              </button>
            }
          </ng-template>
        } @else {
          <!-- all below should be non guest -->

          @if (showConvertToPdfButton) {
            <ng-template
              ngxCompactableItem
              let-location="location"
              let-priority="priority"
            >
              @if (location === 'menu') {
                <button
                  mat-menu-item
                  [attr.data-toolbar-location]="location"
                  [disabled]="isDocumentLoading"
                  (click)="onClickMarkDocumentConversionForSave()"
                >
                  <mat-icon>picture_as_pdf</mat-icon>
                  <span transloco="MARK_CONVERTED_PDF_FOR_SAVE"></span>
                </button>
              } @else {
                <button
                  mat-icon-button
                  [attr.data-toolbar-location]="location"
                  [disabled]="isDocumentLoading"
                  [matTooltip]="'MARK_CONVERTED_PDF_FOR_SAVE' | transloco"
                  (click)="onClickMarkDocumentConversionForSave()"
                >
                  <mat-icon>picture_as_pdf</mat-icon>
                </button>
              }
            </ng-template>
          }
          @if (showAttachmentsMenu) {
            <ng-template
              ngxCompactableItem
              [priority]="1"
              let-location="location"
              let-priority="priority"
            >
              @if (location === 'menu') {
                <app-document-attachments-menu
                  #attachmentMenu
                  [hideMenuTriggerButton]="true"
                  [attachments]="documentAttachments()"
                ></app-document-attachments-menu>
                <button
                  #attachmentTrigger="matMenuTrigger"
                  #attachmentItem="matMenuItem"
                  mat-menu-item
                  [matMenuTriggerFor]="attachmentMenu.menu()"
                  [attr.data-toolbar-location]="location"
                  (mouseenter)="
                    compactableRow.openSubmenu(
                      attachmentTrigger,
                      attachmentItem
                    )
                  "
                >
                  <span transloco="ATTACHMENTS"></span>
                </button>
              } @else {
                <app-document-attachments-menu
                  [attr.data-toolbar-location]="location"
                  [attachments]="documentAttachments()"
                ></app-document-attachments-menu>
              }
            </ng-template>
          }

          @if (showAnnotationsMenu) {
            <ng-template
              ngxCompactableItem
              [priority]="0"
              let-location="location"
              let-priority="priority"
            >
              @if (location === 'menu') {
                <button
                  #trigger="matMenuTrigger"
                  #item="matMenuItem"
                  mat-menu-item
                  [matMenuTriggerFor]="annotationsMenu.menu()"
                  [attr.data-toolbar-location]="location"
                  (mouseenter)="compactableRow.openSubmenu(trigger, item)"
                >
                  <mat-icon>drive_file_rename_outline</mat-icon>
                  <span transloco="ANNOTATE"></span>
                </button>
                <app-annotation-menu
                  #annotationsMenu
                  [hideMenuTriggerButton]="true"
                  [attr.data-toolbar-location]="location"
                ></app-annotation-menu>
              } @else {
                <app-annotation-menu
                  [disableMenu]="kfiActive"
                  [attr.data-toolbar-location]="location"
                ></app-annotation-menu>
              }
            </ng-template>
          }

          @if (showModifyDocumentToggle) {
            <ng-template ngxCompactableItem let-location="location">
              @if (location === 'menu') {
                <button
                  mat-menu-item
                  [attr.data-toolbar-location]="location"
                  [disabled]="modifyDocumentDisabled"
                  (click)="
                    showModifyDocumentThumbnailer =
                      !showModifyDocumentThumbnailer
                  "
                >
                  <mat-icon
                    [class.modify-document-active]="
                      showModifyDocumentThumbnailer
                    "
                    >edit_note</mat-icon
                  >
                  <span transloco="GSG_MODIFY_DOCUMENT"></span>
                </button>
              } @else {
                <button
                  mat-icon-button
                  [class.modify-document-active]="showModifyDocumentThumbnailer"
                  [attr.data-toolbar-location]="location"
                  [matTooltip]="'GSG_MODIFY_DOCUMENT' | transloco"
                  [disabled]="modifyDocumentDisabled"
                  (click)="
                    showModifyDocumentThumbnailer =
                      !showModifyDocumentThumbnailer
                  "
                >
                  <mat-icon>edit_note</mat-icon>
                </button>
              }
            </ng-template>
          }

          <ng-template ngxCompactableItem let-location="location">
            @if (location === 'menu') {
              <app-copy-link-button
                #copyLinkButton
                [attr.data-toolbar-location]="location"
                [inMenu]="true"
                matTooltipPosition="below"
              ></app-copy-link-button>
            } @else {
              <app-copy-link-button
                [attr.data-toolbar-location]="location"
                matTooltipPosition="below"
              ></app-copy-link-button>
            }
          </ng-template>
          @if (newPdfDocumentsExist$ | async; as newPdfDocumentsExist) {
            <ng-template ngxCompactableItem let-location="location">
              @if (location === 'menu') {
                <button
                  mat-menu-item
                  [attr.data-toolbar-location]="location"
                  (click)="onClickOpenNewDocumentsDialog()"
                >
                  <mat-icon
                    [matBadge]="newPdfDocumentCount$ | async"
                    [matBadgeHidden]="!newPdfDocumentsExist"
                  >
                    tab
                  </mat-icon>
                  <span transloco="OPEN_NEW_DOCUMENTS_DIALOG"></span>
                </button>
              } @else {
                <button
                  mat-icon-button
                  (click)="onClickOpenNewDocumentsDialog()"
                  [matTooltip]="'OPEN_NEW_DOCUMENTS_DIALOG' | transloco"
                >
                  <mat-icon
                    [matBadge]="newPdfDocumentCount$ | async"
                    [matBadgeHidden]="!newPdfDocumentsExist"
                    >tab</mat-icon
                  >
                </button>
              }
            </ng-template>
          }

          @if (displayMode === 'inboxIndexing') {
            <ng-template ngxCompactableItem let-location="location">
              @if (location === 'menu') {
                <button
                  mat-menu-item
                  [attr.data-toolbar-location]="location"
                  (click)="onClickCancelIndexing()"
                >
                  <mat-icon>cancel</mat-icon>
                  <span transloco="CANCEL_INDEXING"></span>
                </button>
              } @else {
                <button
                  mat-icon-button
                  [attr.data-toolbar-location]="location"
                  [matTooltip]="'CANCEL_INDEXING' | transloco"
                  matTooltipPosition="below"
                  matTooltipShowDelay="1000"
                  (click)="onClickCancelIndexing()"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              }
            </ng-template>
          }

          @if (!saveInProgress) {
            @if (showSave) {
              <ng-template
                ngxCompactableItem
                [priority]="5"
                let-location="location"
                let-priority="priority"
              >
                @if (location === 'menu') {
                  <button
                    mat-menu-item
                    [disabled]="disableSave"
                    (click)="onClickSave()"
                  >
                    <mat-icon>save</mat-icon>
                    <span transloco="SAVE"></span>
                  </button>
                } @else {
                  <button
                    mat-icon-button
                    [attr.data-toolbar-location]="location"
                    [disabled]="disableSave"
                    [matTooltip]="'SAVE' | transloco"
                    matTooltipPosition="below"
                    matTooltipShowDelay="1000"
                    (click)="onClickSave()"
                  >
                    <mat-icon>save</mat-icon>
                  </button>
                }
              </ng-template>
            }

            @if (showSaveAll) {
              <ng-template
                ngxCompactableItem
                [priority]="5"
                let-location="location"
                let-priority="priority"
              >
                @if (location === 'menu') {
                  <button
                    mat-menu-item
                    [attr.data-toolbar-location]="location"
                    [disabled]="disableSave || (hasAnnotations$ | async)"
                    (click)="onClickSaveAll()"
                  >
                    <mat-icon svgIcon="save_all"></mat-icon>
                    <span transloco="SAVE_ALL"></span>
                  </button>
                } @else {
                  <button
                    mat-icon-button
                    [attr.data-toolbar-location]="location"
                    [disabled]="disableSave || (hasAnnotations$ | async)"
                    [matTooltip]="'SAVE_ALL' | transloco"
                    matTooltipPosition="below"
                    matTooltipShowDelay="1000"
                    (click)="onClickSaveAll()"
                  >
                    <mat-icon svgIcon="save_all"></mat-icon>
                  </button>
                }
              </ng-template>
            }
          }

          <ng-template ngxCompactableItem let-location="location">
            @if (location === 'menu') {
              <button
                mat-menu-item
                [attr.data-toolbar-location]="location"
                (click)="onCloseDocument()"
              >
                <mat-icon>close</mat-icon>
                <span transloco="CLOSE_DOCUMENT"></span>
              </button>
            } @else {
              <button
                mat-icon-button
                [attr.data-toolbar-location]="location"
                [matTooltip]="'CLOSE_DOCUMENT' | transloco"
                matTooltipShowDelay="1000"
                matTooltipPosition="below"
                (click)="onCloseDocument()"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </ng-template>

          @if (displayMode !== 'inbox') {
            @if (showRevisionsMenu$ | async) {
              <!-- TODO this one is going to need the menu rework -->
              <ng-template ngxCompactableItem let-location="location">
                @if (location === 'menu') {
                  <app-revisions-menu
                    #revisionMenu
                    [hideMenuTriggerButton]="true"
                    [multipleDocumentsOpen]="multipleDocumentsOpen"
                    [archiveId]="archiveId"
                    [databaseId]="databaseId"
                    [documentId]="revisionParentDocumentId"
                    [documentSecureId]="revisionParentSecureId"
                    [activeVersion]="activeRevisionNumber"
                  ></app-revisions-menu>
                  <button
                    mat-menu-item
                    #trigger="matMenuTrigger"
                    #item="matMenuItem"
                    [attr.data-toolbar-location]="location"
                    [disabled]="!revisionMenu.hasPermissionToViewRevisions()"
                    [matTooltip]="
                      'VIEWING_REVISION_IN_READONLY_MODE' | transloco
                    "
                    [matTooltipDisabled]="revisionMenu.viewingCurrentRevision()"
                    [matMenuTriggerFor]="revisionMenu.menu()"
                    (mouseenter)="compactableRow.openSubmenu(trigger, item)"
                    (click)="revisionMenu.onClickRevisionMenu()"
                  >
                    <mat-icon
                      [matBadge]="revisionMenu.badgeLabel()"
                      [matBadgeColor]="revisionMenu.badgeColor()"
                      matBadgeSize="small"
                      matBadgeOverlap="true"
                      >history</mat-icon
                    >
                    <span transloco="REVISIONS"></span>
                  </button>
                } @else {
                  <app-revisions-menu
                    [attr.data-toolbar-location]="location"
                    [multipleDocumentsOpen]="multipleDocumentsOpen"
                    [archiveId]="archiveId"
                    [databaseId]="databaseId"
                    [documentId]="revisionParentDocumentId"
                    [documentSecureId]="revisionParentSecureId"
                    [activeVersion]="activeRevisionNumber"
                  ></app-revisions-menu>
                }
              </ng-template>
            }
            <ng-template ngxCompactableItem let-location="location">
              @if (location === 'menu') {
                <button
                  mat-menu-item
                  [attr.data-toolbar-location]="location"
                  [disabled]="isKfiDisabled"
                  (click)="onKfiToggle(false)"
                >
                  @if (!kfiActive) {
                    <mat-icon>flash_on</mat-icon>
                  }
                  <!-- Blue -->
                  @if (kfiActive && !useLocalOcr && !forceOcr) {
                    <mat-icon class="active-keyfree-text-layer"
                      >flash_on</mat-icon
                    >
                  }
                  <!-- Yellow -->
                  @if ((kfiActive && forceOcr) || (kfiActive && useLocalOcr)) {
                    <mat-icon class="active-keyfree-ocr">flash_on</mat-icon>
                  }
                  <span transloco="KEYFREE"></span>
                </button>
              } @else {
                <button
                  mat-icon-button
                  [attr.data-toolbar-location]="location"
                  [disabled]="isKfiDisabled"
                  [matTooltip]="'KEYFREE' | transloco"
                  matTooltipPosition="below"
                  matTooltipShowDelay="1000"
                  (click)="onKfiToggle(false)"
                >
                  @if (!kfiActive) {
                    <mat-icon>flash_on</mat-icon>
                  }
                  <!-- Blue -->
                  @if (kfiActive && !useLocalOcr && !forceOcr) {
                    <mat-icon class="active-keyfree-text-layer"
                      >flash_on</mat-icon
                    >
                  }
                  <!-- Yellow -->
                  @if ((kfiActive && forceOcr) || (kfiActive && useLocalOcr)) {
                    <mat-icon class="active-keyfree-ocr">flash_on</mat-icon>
                  }
                </button>
              }
            </ng-template>
            @if (kfiActive && !useLocalOcr && !forceOcr) {
              <ng-template ngxCompactableItem let-location="location">
                @if (location === 'menu') {
                  <button
                    mat-menu-item
                    [attr.data-toolbar-location]="location"
                    [disabled]="isKfiDisabled"
                    (click)="forceOcr = true"
                  >
                    <mat-icon svgIcon="ocr"></mat-icon>
                    <span transloco="KEYFREE"></span>
                  </button>
                } @else {
                  <button
                    mat-icon-button
                    [attr.data-toolbar-location]="location"
                    [disabled]="isKfiDisabled"
                    [matTooltip]="'KEYFREE' | transloco"
                    matTooltipPosition="below"
                    matTooltipShowDelay="1000"
                    (click)="forceOcr = true"
                  >
                    <mat-icon svgIcon="ocr"></mat-icon>
                  </button>
                }
              </ng-template>
            }
          }

          @if (shouldShowLockedDocumentMenu) {
            <ng-template ngxCompactableItem let-location="location">
              @if (location === 'menu') {
                <app-locked-document-menu
                  #lockMenu
                  [search-result]="documentAsSearchResult"
                  [hideMenuTriggerButton]="true"
                ></app-locked-document-menu>
                @if (lockMenu.isDocumentLocked()) {
                  <button
                    mat-menu-item
                    #trigger="matMenuTrigger"
                    #item="matMenuItem"
                    [attr.data-toolbar-location]="location"
                    [matMenuTriggerFor]="lockMenu.menu()"
                    (mouseenter)="compactableRow.openSubmenu(trigger, item)"
                  >
                    <mat-icon>lock</mat-icon>
                    <span transloco="LOCK_STATUS"></span>
                  </button>
                }
              } @else {
                <app-locked-document-menu
                  [attr.data-toolbar-location]="location"
                  [search-result]="documentAsSearchResult"
                ></app-locked-document-menu>
              }
            </ng-template>
          }

          @if (
            displayMode !== 'inbox' &&
            displayMode !== 'inboxIndexing' &&
            displayMode !== 'archiveRevision'
          ) {
            <ng-template ngxCompactableItem let-location="location">
              @if (location === 'menu') {
                <app-related-searches-menu
                  #relatedSearches
                  [hideMenuTriggerButton]="true"
                  (relatedSearchSelected)="onRelatedSearchSelected($event)"
                ></app-related-searches-menu>
                <button
                  mat-menu-item
                  #trigger="matMenuTrigger"
                  #item="matMenuItem"
                  [attr.data-toolbar-location]="location"
                  [matMenuTriggerFor]="relatedSearches.menu()"
                  (mouseenter)="compactableRow.openSubmenu(trigger, item)"
                >
                  <mat-icon>plagiarism</mat-icon>
                  <span transloco="RELATED_SEARCHES"></span>
                </button>
              } @else {
                <app-related-searches-menu
                  [attr.data-toolbar-location]="location"
                  (relatedSearchSelected)="onRelatedSearchSelected($event)"
                ></app-related-searches-menu>
              }
            </ng-template>
          }

          @if (showDXCMenu) {
            <ng-template ngxCompactableItem let-location="location">
              @if (location === 'menu') {
                <app-dxc-menu
                  #dxcSources
                  [hideMenuTriggerButton]="true"
                  [databaseId]="databaseId"
                  [archiveId]="
                    displayMode === 'inboxIndexing'
                      ? inboxTargetArchiveId
                      : archiveId
                  "
                  (dxcSourceSelected)="onDXCMatchSelected($event)"
                ></app-dxc-menu>
                @if (dxcSources.sources().length > 0) {
                  <button
                    mat-menu-item
                    #trigger="matMenuTrigger"
                    #item="matMenuItem"
                    [attr.data-toolbar-location]="location"
                    [matMenuTriggerFor]="dxcSources.menu()"
                    (mouseenter)="compactableRow.openSubmenu(trigger, item)"
                  >
                    <mat-icon>sync_alt</mat-icon>
                    <span>Data XChange</span>
                  </button>
                }
              } @else {
                <app-dxc-menu
                  [attr.data-toolbar-location]="location"
                  [databaseId]="databaseId"
                  [archiveId]="
                    displayMode === 'inboxIndexing'
                      ? inboxTargetArchiveId
                      : archiveId
                  "
                  (dxcSourceSelected)="onDXCMatchSelected($event)"
                ></app-dxc-menu>
              }
            </ng-template>
          }
        }
      </ngx-compactable-row>
      <!-- The progress spinner should always be in the root. -->
      @if (saveInProgress) {
        <mat-spinner diameter="24" color="accent"></mat-spinner>
      }
      <!-- all below should be non guest -->

      @if (!isGuest) {
        @if (
          displayMode !== 'archiveImport' && displayMode !== 'archiveRevision'
        ) {
          <app-state-toolbar></app-state-toolbar>

          <button
            mat-icon-button
            [disabled]="disableActionMenuButton"
            [matTooltip]="'ACTIONS' | transloco"
            matTooltipShowDelay="1000"
            matTooltipPosition="below"
            (click)="onClickActionMenu($event)"
          >
            <mat-icon>assignment_turned_in</mat-icon>
          </button>
        }
        @if (showToggleIndexer) {
          <button
            mat-icon-button
            [matTooltip]="'TOGGLE_INDEXER' | transloco"
            [disabled]="false"
            matTooltipShowDelay="1000"
            matTooltipPosition="below"
            (click)="onClickToggleIndexer()"
          >
            <mat-icon>vertical_split</mat-icon>
          </button>
        }
      }
    </mat-toolbar>
  </ng-template>
  <!-- Toolbar controls shown to guest users. -->
  <!-- Controls shown to an authenticated user. -->
  <!-- Document pager. Allows moving between multiple open documents. -->
} @else {
  @if (isSearchLoading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  } @else {
    No document matched the query.
  }
}

<!-- Show a progress bar while loading, and a message when no match was found. -->

<!-- Unsupported document output.  -->
<ng-template #unsupportedDocument>
  @if (isUnsupportedDocument) {
    <mat-card class="unsupported-doc-card">
      <mat-card-title
        ><span transloco="UNSUPPORTED_DOCUMENT_FORMAT"></span
      ></mat-card-title>
      <mat-card-content
        ><span transloco="UNSUPPORTED_DOCUMENT_CARD_MSG"></span
      ></mat-card-content>
      @if (!isDownloadDisabled) {
        <mat-card-actions align="end">
          <button mat-button (click)="onClickDownloadDocument()">
            <span transloco="DOWNLOAD"></span>
          </button>
        </mat-card-actions>
      }
    </mat-card>
  }
</ng-template>

<!-- Used to balance centering by placeholding for an icon. -->
